import { BINDING_ATTRIBUTE } from 'src/js/modules/bindings/constants/attributes';
import buildLinkElement from '../../../helpers/build-link-element';
import fieldNames from '../constants/field-names';
import linkTypes from '../constants/link-types';
import buildLinkConfigFromFieldsValues from './build-link-config-from-fields-values';
import prepareLinkConfig from './prepare-link-config';

const buildLinkElementFromFieldsValues = (fieldsValues) => {
  const linkType = fieldsValues[fieldNames.LINK_TYPE];

  if (!linkType) {
    return null;
  }

  const linkConfig = buildLinkConfigFromFieldsValues(linkType, fieldsValues);
  const finalLinkConfig = prepareLinkConfig(linkType, linkConfig);
  const linkElement = buildLinkElement(finalLinkConfig);

  if (linkType === linkTypes.BINDING) {
    const bindingId = fieldsValues[fieldNames.BINDING_ID];

    if (bindingId) {
      linkElement.setAttribute(BINDING_ATTRIBUTE, bindingId);
    }
  }

  return linkElement;
};

export default buildLinkElementFromFieldsValues;
